import { render, staticRenderFns } from "./arrear-detailed-payslip.vue?vue&type=template&id=5c3be394&"
import script from "./arrear-detailed-payslip.vue?vue&type=script&lang=js&"
export * from "./arrear-detailed-payslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports